import { Select, type SelectValue } from '@shared/ui/select';
import { TICKET_CHANNEL_SELECT_OPTIONS } from '@pages/event-send-invitations/lib/invitation-channel-options';
import { TicketTextField } from '@pages/event-send-invitations/ui/ticket-settings-section/components/ticket-text-field';
import { TicketPreview } from '@pages/event-send-invitations/ui/ticket-settings-section/components/ticket-preview';
import { EmailSubjectField } from '@pages/event-send-invitations/ui/shared/email-subject-field';
import styles from './ticket-send-settings-section.module.scss';

export interface TicketSendSettingsValues {
  selectedTicketChannels: SelectValue[];
  isSmsTicketMode: boolean;
  isBothTicketMode: boolean;
  isEmailTicketMode: boolean;
  ticketSmsText: string;
  ticketText: string;
  ticketSubject: string;
  ticketTextParts: number;
  previewLink: string;
}

export interface TicketSendSettingsValidation {
  ticketTypeError?: string | null;
  ticketTextError?: string | null;
}

export interface TicketSendSettingsActions {
  onTicketChannelsChange: (values: SelectValue | SelectValue[]) => void;
  onTicketSubjectChange: (value: string) => void;
  onTicketTextChange: (value: string) => void;
}

interface TicketSendSettingsSectionProps {
  values: TicketSendSettingsValues;
  validation: TicketSendSettingsValidation;
  actions: TicketSendSettingsActions;
}

export const TicketSendSettingsSection = ({ values, validation, actions }: TicketSendSettingsSectionProps) => {
  const {
    selectedTicketChannels,
    isSmsTicketMode,
    isBothTicketMode,
    isEmailTicketMode,
    ticketSmsText,
    ticketText,
    ticketSubject,
    ticketTextParts,
    previewLink,
  } = values;

  const { ticketTypeError, ticketTextError } = validation;
  const { onTicketChannelsChange, onTicketSubjectChange, onTicketTextChange } = actions;

  return (
    <section className={styles.settingsCard}>
      <h2 className={styles.settingsCardTitle}>Настройка билетов</h2>
      <div className={styles.settingsCardContent}>
        <div className={styles.settingsCardFormBlock}>
          <div className={styles.ticketTypeField}>
            <Select
              label="Тип отправки"
              placeholder="Выбрать тип"
              options={TICKET_CHANNEL_SELECT_OPTIONS}
              selectedValue={selectedTicketChannels}
              onChange={onTicketChannelsChange}
              isWithChips
            />
            {ticketTypeError && <span className={styles.fieldError}>{ticketTypeError}</span>}
          </div>

          {isEmailTicketMode && (
            <EmailSubjectField label="Тема билета" subject={ticketSubject} onSubjectChange={onTicketSubjectChange} />
          )}

          <TicketTextField
            isSmsTicketMode={isSmsTicketMode}
            isBothTicketMode={isBothTicketMode}
            isLocked={false}
            showSmsCounter={false}
            ticketSmsText={ticketSmsText}
            ticketText={ticketText}
            ticketTextParts={ticketTextParts}
            ticketTextError={ticketTextError}
            onTicketTextChange={onTicketTextChange}
          />
        </div>
        <TicketPreview isSmsTicketMode={isSmsTicketMode} ticketText={ticketText} previewLink={previewLink} />
      </div>
    </section>
  );
};
